/**
 * @namespace {BX.Main.Popup}
 */
export const CloseIconSize = Object.freeze({
	LARGE: 'large',
	SMALL: 'small',
});
